import { getToken } from '@npm/sso-auth'

import { API_URL } from '../../consts'
import { alertMessage } from '../tools/alertMessage'

interface ApiResponse<T> {
  status: number
  message: string
  data: T
}

const createHeaders = () => {
  const headers = {
    'Content-Type': 'application/json'
  } as Record<string, string>
  const token = getToken()
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}
export const get = async <T>(url: string, params: Record<string, string> = {}): Promise<T> => {
  const urlParams = new URLSearchParams(params).toString()
  const searchParams = urlParams ? `?${urlParams}` : ''
  const response = await fetch(API_URL + url.replace('/api', '') + searchParams, {
    method: 'GET',
    headers: createHeaders()
  })
  const data = (await response.json()) as ApiResponse<T>
  if (data.status !== 10000) {
    // throw new Error(data.message)
    // const error = new Error(data.message)
    // Object.assign(error, { response: data })
    // Promise.reject({ response: data })
    // return
    throw new Error(data.message)
  }
  return data.data
}

export const post = async <T = unknown>(
  url: string,
  body: object,
  config?: {
    alert?: boolean
  }
): Promise<[null | ApiResponse<undefined>, T | null]> => {
  const response = await fetch(API_URL + url.replace('/api', ''), {
    method: 'POST',
    headers: createHeaders(),
    body: JSON.stringify(body)
  })
    .then(async response => (await response.json()) as ApiResponse<T>)
    .catch(error => {
      console.error('请求异常：', error)
      return {
        status: -1,
        message: '请求异常',
        data: undefined
      }
    })

  const data = response
  if (data.status !== 10000) {
    if (config?.alert) {
      const msg = data?.message || '请求失败'
      alertMessage({
        msg,
        type: 'error'
      })
    }
    return [
      {
        status: data.status,
        message: data.message,
        data: undefined
      },
      null
    ]
  }
  return [null, data.data!]
}

export const put = async <T>(url: string, body: object): Promise<T> => {
  const response = await fetch(API_URL + url.replace('/api', ''), {
    method: 'PUT',
    headers: createHeaders(),
    body: JSON.stringify(body)
  })
  const data = (await response.json()) as ApiResponse<T>
  if (data.status !== 10000) {
    const msg = data?.message
    alertMessage({
      msg,
      type: 'error'
    })
    // throw new Error(data.message)
  }
  return data.data
}

export const putFormData = async <T>(url: string, body: FormData | ArrayBuffer): Promise<T> => {
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${getToken()}`
    },
    body
  })
  const data = (await response.json()) as ApiResponse<T>
  if (data.status !== 10000) {
    alertMessage({
      msg: data.message,
      type: 'error'
    })
    // throw new Error(data.message)
  }
  return data.data
}
